var texts = {
  'sv-SE': {
    guestRating: 'Vings gäster'
  },
  'nb-NO': {
    guestRating: 'Vings gjester'
  },
  'da-DK': {
    guestRating: 'Spies gæster'
  },
  'fi-FI': {
    guestRating: 'Asiakkaidemme arviot'
  },
  en: {
    guestRating: 'Guest rating'
  }
};
var texts$1 = texts;

export { texts$1 as default };
//# sourceMappingURL=GuestRating.texts.js.map
